import { SelectField } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAddNewSelector from '@ubeya/shared-web/hooks/useAddNewSelector';
import useCRM from '@ubeya/shared/hooks/account/useCRM';
import { SORT_BY_STRING } from '@ubeya/shared/utils/sorting';
import React, { useContext } from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.div.attrs(() => ({ className: 'uniform-wrapper' }))`
  ${({ $hideBorder }) =>
    $hideBorder &&
    css`
      .select {
        border: none;
        box-shadow: none;
      }
    `}
`;

const ClientCostCentersSelectField = React.forwardRef(
  (
    {
      title,
      name = 'clientBranchCostCenterId',
      clientBranchId,
      hideBorder = false,
      hideTitle = false,
      tooltipBody,
      onChange,
      ...restSelectProps
    },
    ref
  ) => {
    const { t } = useContext(ConfigContext);

    const { mappedClientBranches } = useCRM();
    const clientBranchCostCenters = mappedClientBranches?.[clientBranchId]?.costCenters || [];

    const options = clientBranchCostCenters
      .map(({ id, name: costCenterName, identifier: costCenterIdentifier }) => ({
        value: id,
        label: `${costCenterName} (${costCenterIdentifier})`
      }))
      ?.sort(SORT_BY_STRING);

    const { options: labelOptions, onChange: onChangeCostCenter } = useAddNewSelector({
      options,
      addText: 'addNewLabel',
      enable: false,
      onChange
    });

    return (
      <Wrapper $hideBorder={hideBorder}>
        <SelectField
          ref={ref}
          name={name}
          title={hideTitle ? '' : title ?? t('costCenter')}
          options={labelOptions || {}}
          onChange={onChangeCostCenter}
          usePortal
          isMulti={false}
          showValueAsTooltipBody={!tooltipBody}
          tooltipBody={tooltipBody}
          clearable
          {...restSelectProps}
        />
      </Wrapper>
    );
  }
);

export default ClientCostCentersSelectField;
